export default __webpack_public_path__ + "static/media/paloma.d6bc105c.jpg";